import { render, staticRenderFns } from "./globalSnackBar.vue?vue&type=template&id=974f09f8&scoped=true&"
import script from "./globalSnackBar.vue?vue&type=script&lang=js&"
export * from "./globalSnackBar.vue?vue&type=script&lang=js&"
import style0 from "./globalSnackBar.vue?vue&type=style&index=0&id=974f09f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974f09f8",
  null
  
)

export default component.exports